import React from 'react';
import { useNavigate } from 'react-router-dom';
import './CreditsModal.css';

export default function CreditsModal({ isOpen, onClose }) {
  const navigate = useNavigate();

  if (!isOpen) return null;

  const handleGetCredits = () => {
    onClose();
    navigate('/buy-credits');
  };

  const handleOverlayClick = (e) => {
    if (e.target === e.currentTarget) {
      onClose();
    }
  };

  return (
    <div className="credits-modal-overlay" onClick={handleOverlayClick}>
      <div className="credits-modal">
        <button className="credits-modal-close" onClick={onClose}>
          ✕
        </button>
        
        <h2 className="credits-modal-title">Out of Interview Credits</h2>
        
        <p className="credits-modal-message">
          You don't have any Interview Credits. To start an Interview Session you need to get some credits.
        </p>
        
        <div className="credits-modal-actions">
          <button className="btn-modal btn-modal-close" onClick={onClose}>
            Close
          </button>
          <button className="btn-modal btn-modal-primary" onClick={handleGetCredits}>
            Get Credits
          </button>
        </div>
      </div>
    </div>
  );
}
